/** Seata global transaction names — mirror backend SeataConstants. */
export const SEATA_TX_NAMES = {
    FS_CREATE_STEPPER: 'fs-create-stepper',
    GL_CREATE_STEPPER: 'gl-create-stepper',
    WP_SAVE: 'wp-save',
} as const;
